import {
  Firestore,
  collection,
  doc,
  getDoc,
  updateDoc,
} from "firebase/firestore/lite";
import { firebaseDb } from "../firebase/client-app";
import { DbBusinessSetupStep } from "./models";
import { setCookie } from "cookies-next";

export const CELEBRATION_FLAG_PREFIX = "celebration_shown_";

export const getCelebrationFlagKey = (businessId: string): string => {
  return `${CELEBRATION_FLAG_PREFIX}${businessId}`;
};

export class SetupProgressService {
  private businessesRef(firestore: Firestore) {
    return collection(firestore, "businesses");
  }

  async removeSetupStep(
    businessId: string,
    step: DbBusinessSetupStep,
    firestore: Firestore = firebaseDb,
  ): Promise<void> {
    if (!businessId) {
      return;
    }

    const businessDocRef = doc(this.businessesRef(firestore), businessId);
    const businessDoc = await getDoc(businessDocRef);

    if (!businessDoc.exists()) {
      return;
    }

    const businessData = businessDoc.data();
    const setupProgress: DbBusinessSetupStep[] =
      businessData.remaining_setup_steps || [];

    if (setupProgress.includes(step)) {
      const isLastTask = setupProgress.length === 1;

      const updatedSetupProgress = setupProgress.filter((s) => s !== step);
      await updateDoc(businessDocRef, {
        remaining_setup_steps: updatedSetupProgress,
      });

      if (isLastTask && typeof window !== "undefined") {
        const flagKey = getCelebrationFlagKey(businessId);
        setCookie(flagKey, "true", {
          maxAge: 60 * 60 * 24 * 30,
          path: "/",
        });
      }
    }
  }
}

export const setupProgressService = new SetupProgressService();
